/** ColaTool site-wide nav — keep in sync with web/tools.json (live tools). */

export type ColaToolNavItem = {
  id: string;
  title: string;
  titleZh: string;
  path: string;
  logo: string;
};

export const COLATOOL_CURRENT_TOOL_ID = 'devtools';

export const colatoolNavItems: ColaToolNavItem[] = [
  { id: 'qrcode', title: 'QR Code', titleZh: '二维码', path: '/qrcode/', logo: 'qrcode' },
  { id: 'paint', title: 'Paint', titleZh: '画图', path: '/paint/', logo: 'image' },
  { id: 'photostudio', title: 'PhotoStudio', titleZh: '在线修图', path: '/photostudio/', logo: 'svg' },
  { id: 'image-tool', title: 'Image Tool', titleZh: '图片转换', path: '/image/', logo: 'image' },
  { id: 'omni', title: 'Toolbox', titleZh: '全能工具箱', path: '/toolbox/', logo: 'json' },
  { id: 'devtools', title: 'Dev Tools', titleZh: '开发工具', path: '/devtools/', logo: 'code-image' },
  { id: 'audiomass', title: 'Audio', titleZh: '音频编辑', path: '/audio/', logo: 'hash' },
];
